import React, { Component } from 'react';
import { connect } from 'react-redux';
import Constants from '../../../common/constants/Constants';
import DeploymentStateEnum from '../../../common/constants/DeploymentStateEnum';
import Loading from '../../../common/components/Loading/Loading';
import UpdateJobDetails from './UpdateJobDetails';
import { Lens as CircleIcon } from '@mui/icons-material';
import { getUpdateJobDetails } from './UpdateJobActions';
import { withRouter } from '../../../common/utils/NavigationWrapper';

import PageContainer from '../../../common/components/Page/PageContainer';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';
import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';

class UpdateJobDetailsContainer extends Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      isFetching: true,
      selectedJobName: '',
    };

    this.columnConfigs = [
      {
        name: 'Serial number',
        key: 'SerialNumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'Type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Region',
        key: 'RegionName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Group',
        key: 'GroupName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Location',
        key: 'Location',
        type: 'string',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Software version',
        key: 'SoftwareVersion',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Date and time of last update job status',
        key: 'LastUpdateJobDateTime',
        type: 'datetime',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Update job status',
        key: 'UpdateJobStatus',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Error message',
        key: 'ErrorMessage',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Connection alert',
        key: 'ConnectionAlert.Level',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          var style = {
            width: '.75rem',
            height: '.75rem',
            marginTop: '5px',
            color: el.ConnectionAlert ? el.ConnectionAlert.Color : Constants.COLORS.NEUTRAL,
          };
          return <CircleIcon key={1} style={style} fill={style.color} />;
        },
        visible: true,
        filterable: true,
        sortable: true,
      },
    ];
  }

  componentDidMount() {
    let data = null;
    const { params } = this.props;

    getUpdateJobDetails(params.id)
      .then((res) => {
        data = res.body;
        data.forEach(
          (n) => (n.UpdateJobStatus = DeploymentStateEnum.GetStateName(n.UpdateJobStatus))
        );
        this.setState({ data, isFetching: false, selectedJobName: params.id });
      })
      .catch((err) => this.setState({ isFetching: false }));
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.packageDeploymentMessage) !==
      JSON.stringify(this.props.packageDeploymentMessage)
    ) {
      this._handlePackageDeploymentMessage(this.props.packageDeploymentMessage);
    } else if (
      JSON.stringify(prevProps.transferProgressMessage) !=
      JSON.stringify(this.props.transferProgressMessage)
    ) {
      this._handleTransferProgressMessage(this.props.transferProgressMessage);
    }
  }

  _handlePackageDeploymentMessage = (message) => {
    const { CommandGuid, DeploymentState, ErrorMessage, DeploymentStateTime } = JSON.parse(
      message.data
    );
    let newData = Object.assign([], this.state.data);
    const elIndex = newData.findIndex((el) => el.MessageCommandGuid === CommandGuid);
    if (elIndex === -1) return;
    newData[elIndex] = {
      ...newData[elIndex],
      UpdateJobStatus: DeploymentStateEnum.GetStateName(DeploymentState),
      ErrorMessage: ErrorMessage,
      LastUpdateJobDateTime: DeploymentStateTime,
    };
    this.setState({ data: newData });
  };

  _handleTransferProgressMessage = (message) => {
    const { CommandGuid, FileSize, BytesTransferred, Status } = JSON.parse(message.data);
    let newData = Object.assign([], this.state.data);
    let elIndex = newData.findIndex((el) => el.MessageCommandGuid === CommandGuid);
    if (elIndex === -1) return;
    const percentage = Math.round((BytesTransferred / FileSize) * 100);
    const labeledStatus = Status + ' ' + percentage + '%';

    newData[elIndex] = {
      ...newData[elIndex],
      UpdateJobStatus: labeledStatus,
    };
    this.setState({ data: newData });
  };

  render() {
    return (
      <PageContainer pageName="update-job-details">
        <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_UPDATE_MANAGEMENT}>
          <Loading condition={this.state.isFetching}>
            <div>
              <UpdateJobDetails
                data={this.state.data}
                columnConfigs={this.columnConfigs}
                updateJobName={this.state.selectedJobName}
              />
            </div>
          </Loading>
        </PermissionsCheck>
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  packageDeploymentMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'PackageDeploymentFeedback')
      : null,
  transferProgressMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'FileTransferProgress')
      : null,
});

export default withRouter(connect(mapStateToProps)(UpdateJobDetailsContainer));
